import React from 'react';
import PropTypes from 'prop-types';
import style from './style.css';
import ImageUploader from '../image-uploader';
import { linebreaksToTags, tagsToLinebreaks} from '../../libs/html';

class AdInlineEditForm extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      isEditing: {
        heading: false,
        body: false,
        button: false,
      },
    };

    this.bodyPlaceholder = 'Lägg till brödtext';
    this.headingPlaceholder = 'Lägg till rubrik';
    this.buttonPlaceholder = 'Lägg till länk och text';
    this.buttonTextPlaceholder = 'Text';
    this.buttonLinkPlaceholder = 'Länk';

    this.onEditableButtonBlur = this.onEditableButtonBlur.bind(this);
  }

  componentDidUpdate() {
    this.headingInput && this.headingInput.focus();
    this.bodyInput && this.bodyInput.focus();
  }

  render() {
    const { isEditing } = this.state;
    const {
      image,
      header,
      body,
      link,
      button,
      onHeaderChange,
      onBodyChange,
      onButtonChange,
      onLinkChange,
      onFileSelect,
      onImageChange,
      isDisabled,
      imageUrls,
    } = this.props;

    return (
      <div className={ style.ad }>
        <ImageUploader
          image={ image }
          onFileSelect={ onFileSelect }
          onImageChange={ onImageChange }
          isDisabled={ isDisabled }
          imageUrls={ imageUrls }
        />
        <div className={ style.content }>
          {
            isEditing.heading
              ? (
                <input
                  type="text"
                  className={ style.headingField }
                  value={ header }
                  onChange={ onHeaderChange }
                  ref={element => {
                    this.headingInput = element;
                  }}
                  placeholder={ this.headingPlaceholder }
                  onBlur={ this.onEditableBlur.bind(this, 'heading') }
                />
              )
              : (
                <div
                  className={ style.heading }
                  onClick={ this.onEditableClick.bind(this, 'heading') }
                >{ header || this.headingPlaceholder }</div>
              )
          }
          {
            isEditing.body
              ? (
                <textarea
                  className={ style.bodyField }
                  value={ tagsToLinebreaks(body) }
                  onChange={ (event) => {
                    onBodyChange({
                      ...event,
                      target: {
                        ...event.target,
                        value: linebreaksToTags(event.target.value),
                      },
                    });
                  } }
                  rows="3"
                  ref={element => {
                    this.bodyInput = element;
                  }}
                  placeholder={ this.bodyPlaceholder }
                  onBlur={ this.onEditableBlur.bind(this, 'body') }
                />
              )
              : (
                <p
                  className={ style.body }
                  onClick={ this.onEditableClick.bind(this, 'body') }
                  onBlur={ this.onEditableBlur.bind(this, 'body') }
                  dangerouslySetInnerHTML={ {__html: body || this.bodyPlaceholder }}
                />
              )
          }
          <span
            className={ style.button }
            onClick={ this.onEditableClick.bind(this, 'button') }
          >
            { button || this.buttonPlaceholder }
          </span>
          {
            isEditing.button
              ? (
                <div className={style.buttonBoxContainer}>
                  <div className={style.buttonBox}>
                    <label className={style.label}>Text
                      <input
                        type="text"
                        value={ button }
                        onChange={ onButtonChange}
                        className={style.input}
                        ref={element => {
                          this.buttonInput = element;
                        }}
                        placeholder={ this.buttonTextPlaceholder }
                        onBlur={ this.onEditableButtonBlur }
                      />
                    </label>
                    <label className={style.label}>Länk
                      <input
                        type="text"
                        value={ link }
                        onChange={ onLinkChange }
                        className={style.input}
                        ref={element => {
                          this.linkInput = element;
                        }}
                        placeholder={ this.buttonLinkPlaceholder }
                        onBlur={ this.onEditableButtonBlur }
                      />
                    </label>
                  </div>
                </div>
              )
              : null
          }
        </div>
      </div>
    );
  }

  onEditableClick(field /*, event*/) {
    const { isEditing } = this.state;
    this.setState({ isEditing: { ...isEditing, [field]: true } });
  }

  onEditableBlur(field /*, event*/) {
    const { isEditing } = this.state;
    this.setState({ isEditing: { ...isEditing, [field]: false } });
  }

  onEditableButtonBlur(/*event*/) {
    setTimeout(() => {
      const { activeElement } = document;
      if (activeElement === this.buttonInput || activeElement === this.linkInput) {
        return;
      }

      const { isEditing } = this.state;
      this.setState({ isEditing: { ...isEditing, button: false } });
    }, 0);
  }
}

AdInlineEditForm.propTypes = {
  image: PropTypes.string,
  header: PropTypes.string,
  body: PropTypes.string,
  link: PropTypes.string,
  button: PropTypes.string,

  onImageChange: PropTypes.func.isRequired,
  onHeaderChange: PropTypes.func.isRequired,
  onBodyChange: PropTypes.func.isRequired,
  onLinkChange: PropTypes.func.isRequired,
  onButtonChange: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  onFileSelect: PropTypes.func.isRequired,
  imageUrls: PropTypes.array.isRequired,
};

export default AdInlineEditForm;



// WEBPACK FOOTER //
// ./client/src/components/ad-inline-edit-form/index.js